import React, { useState } from 'react';
import { Paper, Typography, TextField, Button, Switch, FormGroup, FormControlLabel, Avatar, Box } from '@mui/material';
import { useEnableIntentProductMutation } from '../../../../features/organizations/organizationsApiSlice';

const Intent = ({ organization }) => {
  const [awsAccountId, setAwsAccountId] = useState(organization?.aws_account_id || '');
  const [isIntentActive, setIsIntentActive] = useState(organization?.products.includes('Intent Feed'));
  const [localIntentActive, setLocalIntentActive] = useState(isIntentActive);
  
  const [enableIntentProduct, { isLoading }] = useEnableIntentProductMutation();

  const handleToggleIntent = (event) => {
    // Update local toggle state, do not call API here
    setLocalIntentActive(event.target.checked);
  };

  const handleAwsAccountIdChange = (event) => {
    setAwsAccountId(event.target.value);
  };

  const handleSaveChanges = async () => {
    // Call the API to update the organization with the current state of the intent toggle and AWS Account ID
    if (isIntentActive !== localIntentActive || awsAccountId !== organization.aws_account_id) {
      await enableIntentProduct({ 
        id: organization._id, 
        enable_intent_product: localIntentActive, 
        aws_account_id: awsAccountId 
      });
      setIsIntentActive(localIntentActive); // Update the main state after API call
    }
  };

  return (
    <Paper elevation={3} sx={{ padding: 3, display: 'flex', justifyContent: 'space-between', gap: 2 }}>
      {/* Status and Configurations */}
      <Box sx={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
        <Paper elevation={2} sx={{ padding: 2, marginBottom: 2 }}>
          <Typography variant="h6">Intent Delivery Status</Typography>
          <Avatar sx={{ bgcolor: localIntentActive ? 'green' : 'red', width: 24, height: 24, marginLeft: 2 }} />
        </Paper>

        {/* Form for AWS Account and Enable Toggle */}
        <TextField
          label="AWS Role ARN"
          variant="outlined"
          fullWidth
          margin="normal"
          value={awsAccountId}
          onChange={handleAwsAccountIdChange}
          disabled={isLoading}
        />
        <FormGroup>
          <FormControlLabel
            control={<Switch checked={localIntentActive} onChange={handleToggleIntent} disabled={isLoading} />}
            label="Enable Intent"
          />
        </FormGroup>
        <Button variant="contained" color="primary" sx={{ marginTop: 2 }} onClick={handleSaveChanges} disabled={isLoading}>
          Save Changes
        </Button>
      </Box>

      {/* Explanation and S3 Location */}
      <Paper elevation={2} sx={{ padding: 2, width: '45%' }}>
        <Typography variant="h6">What is an Intent Data Feed?</Typography>
        <Typography>
          An intent data feed provides insights into user behaviors and preferences, enabling targeted engagement strategies.
        </Typography>
        <Typography variant="subtitle1" sx={{ marginTop: 2 }}>
          S3 Location:
        </Typography>
        <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
          s3://trovo-coop-fe-sync/incoming/AIGDS/
        </Typography>
      </Paper>
    </Paper>
  );
};

export default Intent;
